import { Resource } from "../../utils/types/AiTypes";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { API_AI_RESOURCE_FOR_ORG_ADMIN_ENDPOINT } from "../../utils/constants";

export interface ResourcesState {
  resources: Resource[];
  currentPage: number;
  size: number;
  totalPage: number;
  totalElements: number;
  status: "fulfilled" | "pending" | "rejected" | "idle";
}

export interface ResourceListPagination {
  data: Resource[];
  currentPage: number;
  totalPage: number;
  totalElements: number;
}

const initialState: ResourcesState = {
  resources: [],
  currentPage: 1,
  size: 10,
  totalPage: 1,
  totalElements: 0,
  status: "idle",
};

export const fetchResourceByPackage = createAsyncThunk(
  "resources/fetchByPackage",
  async (params: {
    keycloak: Keycloak.KeycloakInstance;
    packageId?: number;
    page: number;
    size: number;
  }): Promise<Resource[]> => {
    const { keycloak, packageId, page, size } = params;
    const res = await axios.get(`${API_AI_RESOURCE_FOR_ORG_ADMIN_ENDPOINT}`, {
      params: {
        packageId: packageId,
        page: page,
        size: size,
      },
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${keycloak?.token}`,
      },
      withCredentials: true,
    });
    return res.data;
  },
);

export const ResourceSlice = createSlice({
  name: "resource",
  initialState,
  reducers: {
    getResources: (state, action) => {
      state.status = "fulfilled";
      state.resources = action.payload.data;
      state.currentPage = action.payload.currentPage;
      state.totalPage = action.payload.totalPage;
    },
    failedToGetResources: (state) => {
      state.status = "rejected";
      state = initialState;
    },
    resetResourceState: (state) => {
      state = initialState;
    },
    removeResource: (state, action) => {
      state.resources = state.resources.filter(
        (resource) => resource.uuid !== action.payload,
      );
      state.totalElements = Math.max(0, state.totalElements - 1);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchResourceByPackage.fulfilled, (state, action) => {
      state.status = "fulfilled";
      state.resources = action.payload;
      // state.currentPage = action.payload.currentPage;
      // state.totalPage = action.payload.totalPage;
      // state.totalElements = action.payload.totalElements;
    });
  },
});

export const {
  getResources,
  failedToGetResources,
  resetResourceState,
  removeResource,
} = ResourceSlice.actions;
export default ResourceSlice.reducer;
